/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import React, { useEffect, useState } from 'react';
import { useParams, NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import YouTube from 'react-youtube';

// @mui material components
import Card from '@mui/material/Card';
import Icon from '@mui/material/Icon';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Pagination from '@mui/material/Pagination';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import InputAdornment from '@mui/material/InputAdornment';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Chip from '@mui/material/Chip'; // งานข้อ 6 — ป้ายสถานะแคมเปญ

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';
import MDInput from 'components/MDInput';
import MDCheckbox from 'components/MDCheckbox';
import MDSelect from 'components/MDSelect';
import TableHeader from 'components/Table/TableHeader';
import MDTypography from 'components/MDTypography';
import TabPanel from 'components/TabPanel/TabPanel';
import MDEditor from 'components/MDEditor';
import MDDatePicker from 'components/MDDatePicker';

// Material Dashboard 2 PRO React examples
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import Navbar from 'examples/Navbars/NavBar';
import Footer from 'examples/Footer';
import { APP_STATE } from 'services/Define';
import { FetchData } from 'services/Request';
import * as Func from 'services/Function';
import CampaignGraphicPicker from 'layouts/_entrio/CampaignGraphicPicker'; // ตั้งภาพหลักจากกราฟิก AI (26 ต.ค. 2569)
import CampaignUpload from './CampaignUpload';
import CampaignBranch from './CampaignBranch';
import CampaignList from './CampaignList';
import CampaignFree from './CampaignFree';
import CampaignBranchUse from './CampaignBranchUse';
import CampaignGraphic from './CampaignGraphic'; // งานข้อ 6.5 — กราฟิกแคมเปญด้วย AI

const initAttr = {
  id: '',
  code: '',
  cat_id: '',
  subcat_id: '',
  image_id: '',
  unit_id: '',
  unitadd_id: '',
  unitbuy_id: '',
  brand_id: '',
  color_id: '',
  vat_id: '2',
  image: '',
  name: '',
  name_en: '',
  promotion_name: '',
  promotion_name_en: '',
  detail: '',
  detail_en: '',
  content: '',
  content_en: '',
  cost: '',
  price: '',
  amount: '',
  youtube: '',
  quantity: '',
  all_branch: 'Y',
  is_all_products: 'N',
  active_buy: 'Y',
  promotion_type: 'A',
  enable: 'Y',
  created_at: '',
  updated_at: '',
  date_start: Func.dateNow(),
  time_start: '00:00',
  date_stop: Func.dateAdd(365),
  time_stop: '00:00',
};

const initNavigate = {
  first: '',
  prev: '',
  next: '',
  last: '',
};

const initFind = {
  search: '',
  order_by: 'tb.sort',
  order_sort: 'asc',
  page: 1,
  perPage: 10,
  pageTotal: 0,
  type: 'ALL',
  enable: 'Y',
  expire: 'Y',
};

function Campaign() {
  const mod = 'campaign';
  const app = useSelector((state) => state[APP_STATE]);
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const [pageTotal, setPageTotal] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [record, setRecord] = useState([]);
  const [show, setShow] = useState(null);
  const [attr, setAttr] = useState(initAttr);
  const [find, setFind] = useState(initFind);
  const [navigate, setNavigate] = useState(initNavigate);
  const [notify, setNotify] = useState(null);
  const [confirm, setConfirm] = useState(false);
  const [loading, setLoading] = useState(true);
  const [order, setOrder] = useState(initFind.order_sort);
  const [orderBy, setOrderBy] = useState(initFind.order_by);
  const [modalAdd, setModalAdd] = useState(false);
  const [cboType, setCboType] = useState([]);
  const [cboVatType, setCboVatType] = useState([]);
  const [image, setImage] = useState([]);
  const [tab, setTab] = useState(0);
  const [pickGraphic, setPickGraphic] = useState(false);
  const [content, setContent] = useState('');
  const [contentEN, setContentEN] = useState('');
  const [promotion, setPromotion] = useState('A');
  const [copyFrom, setCopyFrom] = useState('');
  const [copyTo, setCopyTo] = useState('');
  const [urlExcel, setUrlExcel] = useState('');

  const openShow = (e) => setShow(e.currentTarget);
  const closeShow = () => setShow(null);

  const initHeader = [
    { id: 'tb.sort', label: t(`attr.image`), align: 'left', width: 40 },
    { id: 'tb.code', label: 'แคมเปญ', align: 'left' },
    { id: 'tb.promotion_type', label: 'ประเภท', align: 'left' },
    { id: 'tb.date_stop', label: 'เริ่ม - สิ้นสุด', align: 'center' },
    { id: 'tb.all_branch', label: 'สาขา', align: 'center' },
    { id: 'tb.quantity', label: 'ซื้อครบ', align: 'right', width: 120 },
    { id: 'tb.price', label: 'มูลค่า', align: 'center', width: 120 },
    { id: 'tb.enable', label: t(`attr.enable`), align: 'center', width: 40 },
    { id: 'move', label: '', align: 'center', width: 20, sort: false },
  ];

  const showNotify = (msg, color) => {
    setNotify(
      <Snackbar
        open
        autoHideDuration={3000}
        onClose={() => setNotify(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert onClose={() => setNotify(null)} severity={color} variant='filled'>
          {msg}
        </Alert>
      </Snackbar>
    );
  };

  const view = (data) => {
    setFind(data);
    setLoading(true);
    closeShow();

    FetchData('POST', `/${mod}`, app.token, {
      lang: app.lang,
      search: data.search,
      page: data.page,
      per_page: data.perPage,
      orderby: data.order_by,
      ordersort: data.order_sort,
      type: data.type,
      enable: data.enable,
      expire: data.expire,
    }).then((result) => {
      if (result.status === 'ok') {
        setRecord(result.data);

        setPageTotal(result.total_pages);
        setPageNo(result.page);
      }
      setLoading(false);
    });
  };

  const open = () => {
    setLoading(true);
    setConfirm(false);
    setAttr(initAttr);
    setTab(0);

    FetchData('GET', `/${mod}/${id}`, app.token, {
      lang: app.lang,
    }).then((result) => {
      if (result.status === 'ok') {
        setNavigate(result.navigate);
        setAttr(result.data);
        setContent(result.data.content);
        setContentEN(result.data.content_en);
        setImage(result.image);
        setPromotion(result.data.promotion_type);

        setLoading(false);
      }
    });
  };

  const reload = (item) => {
    setAttr({ ...attr, price: item.price });
  };

  const reloadList = () => {
    view(find);
  };

  const reloadInfo = () => {
    open();
  };

  /* หลังเก็บภาพจากแท็บกราฟิก AI — โหลดเฉพาะรูป ไม่เรียก open() ที่ดีดกลับแท็บแรก (18 ต.ค. 2569) */
  const reloadImages = () =>
    FetchData('GET', `/${mod}/${id}`, app.token, { lang: app.lang })
      .then((result) => {
        if (result.status !== 'ok') return;
        setImage(result.image);
        setAttr((prev) => ({ ...prev, image: result.data.image, image_id: result.data.image_id }));
      })
      .catch(() => {});

  const addConfirm = () => {
    // if (!Func.verifyLength(attr.code, 1)) return;
    if (!Func.verifyLength(attr.name, 1)) return;
    if (!Func.verifyLength(attr.promotion_type, 1)) return;

    setConfirm(true);
  };

  const add = () => {
    setLoading(true);
    setModalAdd(false);

    FetchData('PUT', `/${mod}`, app.token, {
      // code: attr.code,
      name: attr.name,
      promotion_name: attr.promotion_name,
      promotion_type: attr.promotion_type,
      date_start: attr.date_start,
      time_start: attr.time_start,
      date_stop: attr.date_stop,
      time_stop: attr.time_stop,
    }).then((result) => {
      setLoading(false);

      if (result.status === 'ok') {
        window.location.replace(`${mod}/${result.id}`);
        showNotify(t(`alert.addcomplete`), 'success');
      } else {
        setModalAdd(true);
        showNotify(t(`alert.saveerror`), 'error');
      }
    });
  };

  const editConfirm = () => {
    if (!Func.verifyLength(attr.name, 1)) return false;
    if (!Func.verifyLength(attr.promotion_type, 1)) return false;

    return true;
  };

  const edit = () => {
    if (!editConfirm()) return;

    Swal.fire({
      title: t(`alert.confirm_edit_title`),
      icon: 'warning',
      showDenyButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: t(`element.save`),
      denyButtonText: t(`element.cancel`),
      denyButtonColor: '#dc3545',
      reverseButtons: true,
    }).then((swal) => {
      if (swal.isConfirmed) {
        setLoading(true);
        setConfirm(false);

        FetchData('PATCH', `/${mod}/${attr.id}`, app.token, {
          cat_id: attr.cat_id,
          subcat_id: attr.subcat_id,
          vat_id: attr.vat_id,
          // code: attr.code,
          name: attr.name,
          name_en: attr.name_en,
          promotion_name: attr.promotion_name,
          promotion_name_en: attr.promotion_name_en,
          detail: attr.detail,
          detail_en: attr.detail_en,
          price: attr.price,
          unit_id: attr.unit_id,
          promotion_type: attr.promotion_type,
          quantity: attr.quantity,
          amount: attr.amount,
          enable: attr.enable,
          date_start: attr.date_start,
          time_start: attr.time_start,
          date_stop: attr.date_stop,
          time_stop: attr.time_stop,
        }).then((result) => {
          setLoading(false);

          if (result.status === 'ok') {
            setPromotion(attr.promotion_type);
            showNotify(t(`alert.editcomplete`), 'success');
          } else {
            setConfirm(false);
            showNotify(result.msg, 'error');
          }
        });
      }
    });
  };

  const copy = () => {
    Swal.fire({
      title: 'คุณต้องการคัดลอกแคมเปญนี้เป็นแคมเปญใหม่ใช่หรือไม่',
      icon: 'warning',
      showDenyButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'ใช่',
      denyButtonText: t(`element.cancel`),
      denyButtonColor: '#dc3545',
      reverseButtons: true,
    }).then((swal) => {
      if (swal.isConfirmed) {
        setLoading(true);
        setConfirm(false);

        FetchData('OPTIONS', `/${mod}/copy`, app.token, {
          id: attr.id,
        }).then((result) => {
          setLoading(false);

          if (result.status === 'ok') {
            showNotify(t(`alert.editcomplete`), 'success');
            window.location.replace(`/${mod}/${result.id}`);
          } else {
            showNotify(result.msg, 'error');
          }
        });
      }
    });
  };

  const editPromotionA = () => {
    Swal.fire({
      title: t(`alert.confirm_edit_title`),
      icon: 'warning',
      showDenyButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: t(`element.save`),
      denyButtonText: t(`element.cancel`),
      denyButtonColor: '#dc3545',
      reverseButtons: true,
    }).then((swal) => {
      if (swal.isConfirmed) {
        setLoading(true);
        setConfirm(false);

        FetchData('PATCH', `/${mod}/${attr.id}`, app.token, {
          quantity: attr.quantity,
          price: attr.price,
        }).then((result) => {
          setLoading(false);

          if (result.status === 'ok') {
            setPromotion(attr.promotion_type);
            showNotify(t(`alert.editcomplete`), 'success');
          } else {
            setConfirm(false);
            showNotify(t(`alert.${result.msg}`), 'error');
          }
        });
      }
    });
  };

  const editPromotionB = () => {
    Swal.fire({
      title: t(`alert.confirm_edit_title`),
      icon: 'warning',
      showDenyButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: t(`element.save`),
      denyButtonText: t(`element.cancel`),
      denyButtonColor: '#dc3545',
      reverseButtons: true,
    }).then((swal) => {
      if (swal.isConfirmed) {
        setLoading(true);
        setConfirm(false);

        FetchData('PATCH', `/${mod}/${attr.id}`, app.token, {
          price: attr.price,
        }).then((result) => {
          setLoading(false);

          if (result.status === 'ok') {
            setPromotion(attr.promotion_type);
            showNotify(t(`alert.editcomplete`), 'success');
          } else {
            setConfirm(false);
            showNotify(t(`alert.${result.msg}`), 'error');
          }
        });
      }
    });
  };

  const editPromotionC = () => {
    Swal.fire({
      title: t(`alert.confirm_edit_title`),
      icon: 'warning',
      showDenyButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: t(`element.save`),
      denyButtonText: t(`element.cancel`),
      denyButtonColor: '#dc3545',
      reverseButtons: true,
    }).then((swal) => {
      if (swal.isConfirmed) {
        setLoading(true);
        setConfirm(false);

        FetchData('PATCH', `/${mod}/${attr.id}`, app.token, {
          quantity: attr.quantity,
          amount: attr.amount,
        }).then((result) => {
          setLoading(false);

          if (result.status === 'ok') {
            setPromotion(attr.promotion_type);
            showNotify(t(`alert.editcomplete`), 'success');
          } else {
            setConfirm(false);
            showNotify(t(`alert.${result.msg}`), 'error');
          }
        });
      }
    });
  };

  const editPromotionE = () => {
    Swal.fire({
      title: t(`alert.confirm_edit_title`),
      icon: 'warning',
      showDenyButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: t(`element.save`),
      denyButtonText: t(`element.cancel`),
      denyButtonColor: '#dc3545',
      reverseButtons: true,
    }).then((swal) => {
      if (swal.isConfirmed) {
        setLoading(true);
        setConfirm(false);

        FetchData('PATCH', `/${mod}/${attr.id}`, app.token, {
          quantity: attr.quantity,
          price: attr.price,
        }).then((result) => {
          setLoading(false);

          if (result.status === 'ok') {
            setPromotion(attr.promotion_type);
            showNotify(t(`alert.editcomplete`), 'success');
          } else {
            setConfirm(false);
            showNotify(t(`alert.${result.msg}`), 'error');
          }
        });
      }
    });
  };

  const editYoutube = () => {
    setLoading(true);

    FetchData('PATCH', `/${mod}/${attr.id}`, app.token, {
      youtube: attr.youtube,
    }).then((result) => {
      setLoading(false);

      if (result.status === 'ok') {
        showNotify(t(`alert.editcomplete`), 'success');
      } else {
        setConfirm(false);
        showNotify(t(`alert.${result.msg}`), 'error');
      }
    });
  };

  const editContent = () => {
    setLoading(true);

    FetchData('PATCH', `/${mod}/${attr.id}`, app.token, {
      content: content,
      content_en: contentEN,
    }).then((result) => {
      setLoading(false);

      if (result.status === 'ok') {
        showNotify(t(`alert.editcomplete`), 'success');
      } else {
        setConfirm(false);
        showNotify(t(`alert.${result.msg}`), 'error');
      }
    });
  };

  const upload = (filedata) => {
    setLoading(true);

    FetchData('OPTIONS', `/${mod}/upload`, app.token, {
      id: id,
      filedata: filedata,
    }).then((result) => {
      open();
      setLoading(false);

      if (result.status === 'ok') {
        showNotify(t(`alert.editcomplete`), 'success');
      } else {
        showNotify(t(`alert.saveerror`), 'error');
      }
    });
  };

  const pin = (image_id) => {
    setLoading(true);

    FetchData('OPTIONS', `/${mod}/pin`, app.token, {
      id: id,
      image_id: image_id,
    }).then((result) => {
      open();
      setLoading(false);

      if (result.status === 'ok') {
        showNotify(t(`alert.editcomplete`), 'success');
      } else {
        showNotify(t(`alert.saveerror`), 'error');
      }
    });
  };

  const move = (item) => {
    if (copyFrom === item.id && copyFrom !== '') {
      setCopyFrom('');
      setCopyTo('');
      return;
    }

    if (copyFrom === '') {
      setCopyFrom(item.id);
      return;
    }

    setCopyTo(item.id);

    Swal.fire({
      title: 'คุณต้องการย้ายตำแหน่ง ใช่หรือไม่?',
      icon: 'warning',
      showDenyButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: t(`element.save`),
      denyButtonText: t(`element.cancel`),
      denyButtonColor: '#dc3545',
      reverseButtons: true,
    }).then((swal) => {
      if (swal.isConfirmed) {
        setLoading(true);

        FetchData('OPTIONS', `/${mod}/move`, app.token, {
          id: copyFrom,
          replace: item.id,
        }).then((result) => {
          setCopyFrom('');
          setCopyTo('');
          setLoading(false);

          if (result.status === 'ok') {
            view(find);
            showNotify(t(`alert.editcomplete`), 'success');
          } else {
            showNotify(t(`alert.saveerror`), 'error');
          }
        });
      } else {
        setCopyFrom('');
        setCopyTo('');
      }
    });
  };

  const renderLoading = () => {
    return (
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color='inherit' />
      </Backdrop>
    );
  };

  const promotionDisplay = (inp) => {
    if (inp === 'A') return <code className='color-success'>A : ซื้อครบจำนวนลดราคา</code>;
    if (inp === 'B') return <code className='color-primary'>B : ซื้อครบมูลค่าได้ของแถม</code>;
    if (inp === 'C') return <code className='color-info'>C : ซื้อครบจำนวนได้ของแถม</code>;
    if (inp === 'D') return <code className='color-danger'>D : ยิ่งซื้อยิ่งลด</code>;
    if (inp === 'E') return <code className='color-warning'>E : ซื้อครบมูลค่าได้ส่วนลด</code>;
    return '';
  };

  const renderShow = (
    <Menu
      anchorEl={show}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      open={Boolean(show)}
      onClose={closeShow}
      keepMounted
    >
      <MenuItem onClick={() => view({ ...find, page: 1, perPage: 10 })}>
        {t(`element.show_record`, { num: 10 })}
      </MenuItem>
      <MenuItem onClick={() => view({ ...find, page: 1, perPage: 20 })}>
        {t(`element.show_record`, { num: 20 })}
      </MenuItem>
      <MenuItem onClick={() => view({ ...find, page: 1, perPage: 100 })}>
        {t(`element.show_record`, { num: 100 })}
      </MenuItem>
    </Menu>
  );

  const handleSort = (e, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);

    view({ ...find, order_by: property, order_sort: isAsc ? 'desc' : 'asc' });
  };

  const init = () => {
    FetchData('GET', `/${mod}`, app.token, {
      lang: app.lang,
    }).then((result) => {
      if (result.status === 'ok') {
        setAttr(initAttr);
        setCboVatType(result.vattype);
        setCboType(result.type);
        setUrlExcel(result.excel);

        if (id === undefined) {
          view(find);
        } else {
          open();
        }
      } else {
        Func.exitApp();
      }
    });
  };

  const excel = () => {
    const params = new URLSearchParams();
    params.append('search', find.search);
    params.append('type', find.type);
    params.append('enable', find.enable);
    params.append('expire', find.expire);
    params.append('orderby', find.order_by);
    params.append('ordersort', find.order_sort);

    const url = `${urlExcel}/download?${params.toString()}`;
    window.open(url, '_self');
  };

  const enableDisplay = (inp) => {
    if (inp === 'Y') return <Icon color='info'>verified</Icon>;
    return <Icon color='error'>not_interested</Icon>;
  };

  const btnOpen = (item) => {
    return (
      <NavLink to={`/${mod}/${item.id}`}>
        <MDButton
          variant='text'
          color='info'
          size='small'
          sx={{ fontSize: '1rem', display: 'inline-block', textAlign: 'left', p: 0 }}
        >
          {item.code}
        </MDButton>
      </NavLink>
    );
  };

  const btnMove = (item) => {
    return (
      <IconButton
        aria-label='up'
        variant='gradient'
        color={copyFrom === item.id ? 'error' : copyTo === item.id ? 'success' : 'dark'}
        size='small'
        onClick={() => move(item)}
      >
        <Icon>move_up</Icon>
      </IconButton>
    );
  };

  const renderSearch = () => {
    return (
      <Card sx={{ p: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={6} lg={3}>
            <MDBox
              noValidate
              component='form'
              role='form'
              onSubmit={(e) => {
                e.preventDefault();
                view({ ...find, period: 'ALL', page: 1 });
              }}
            >
              <MDInput
                name='searchform'
                fullWidth
                value={find.search}
                type='search'
                onChange={(e) => setFind({ ...find, search: e.target.value, page: 1 })}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position='start'>{t('element.search')} :</InputAdornment>
                  ),
                  autoComplete: 'off',
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={3}>
            <MDInput
              fullWidth
              value={find.type}
              defaultValue='ALL'
              select
              onChange={(e) => view({ ...find, type: e.target.value, page: 1 })}
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>
                    <span>ประเภท :</span>
                  </InputAdornment>
                ),
              }}
            >
              <MenuItem value='ALL'>ทั้งหมด</MenuItem>
              {cboType.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </MDInput>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={2}>
            <MDInput
              fullWidth
              value={find.expire}
              defaultValue='ALL'
              select
              onChange={(e) => view({ ...find, expire: e.target.value, page: 1 })}
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>
                    <span>ช่วงเวลา :</span>
                  </InputAdornment>
                ),
              }}
            >
              <MenuItem value='ALL'>ทั้งหมด</MenuItem>
              <MenuItem value='Y'>ใช้งาน</MenuItem>
              <MenuItem value='N'>หมดอายุ</MenuItem>
            </MDInput>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={2}>
            <MDInput
              fullWidth
              value={find.enable}
              defaultValue='ALL'
              select
              onChange={(e) => view({ ...find, enable: e.target.value, page: 1 })}
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>
                    <span>เปิดใช้ :</span>
                  </InputAdornment>
                ),
              }}
            >
              <MenuItem value='ALL'>ทั้งหมด</MenuItem>
              <MenuItem value='Y'>เปิด</MenuItem>
              <MenuItem value='N'>ปิด</MenuItem>
            </MDInput>
          </Grid>
          <Grid item xs={12} sm={3} md={3} lg={2}>
            <MDBox
              noValidate
              component='form'
              role='form'
              onSubmit={(e) => {
                e.preventDefault();
                view(find);
              }}
            >
              <MDInput
                name='searchpage'
                fullWidth
                value={find.page}
                type='number'
                onChange={(e) => setFind({ ...find, page: e.target.value })}
                onFocus={(e) => e.target.select()}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position='start'>{t('element.page')} :</InputAdornment>
                  ),
                  autoComplete: 'off',
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12}>
            <MDBox display='flex' justifyContent='end' gap={1}>
              <MDButton variant='gradient' color='success' onClick={excel}>
                <Icon>table_view</Icon>&nbsp;Excel
              </MDButton>
            </MDBox>
          </Grid>
        </Grid>
      </Card>
    );
  };

  const dateStartStop = (item) => {
    if (item.check_date === 'N')
      return (
        <span className='color-danger'>
          {Func.dateDisplay(item.date_start)} - {Func.dateDisplay(item.date_stop)}
        </span>
      );

    return (
      <span>
        {Func.dateDisplay(item.date_start)} - {Func.dateDisplay(item.date_stop)}
      </span>
    );
  };

  /* ─────────────────────────────────────────────────────────────────────
     งานปรับปรุง ERP 2569 · ข้อ 6 — ป้ายสถานะแคมเปญ

     backend คำนวณ campaign_status กับ days_left มาให้จากวันที่ตอน query
     (campaign.con.php statusSelect) ฝั่งนี้แค่แปลงเป็นป้ายสี ไม่คำนวณซ้ำ
     จะได้ไม่มีทางที่หน้าจอกับ cron แจ้งเตือนคิดไม่ตรงกัน

     จำนวนวันที่ถือว่า "ใกล้หมดอายุ" ตั้งที่ configs.campaign_expiry_days
     ───────────────────────────────────────────────────────────────────── */
  const campaignStatus = {
    DRAFT: { label: 'ปิดใช้งาน', color: 'default' }, // DRAFT = enable 'N' (campaign.con.php statusSelect)
    SCHEDULED: { label: 'ยังไม่เริ่ม', color: 'info' },
    ACTIVE: { label: 'ใช้อยู่', color: 'success' },
    EXPIRING: { label: 'ใกล้หมดอายุ', color: 'warning' },
    EXPIRED: { label: 'หมดอายุแล้ว', color: 'error' },
  };

  const statusChip = (item) => {
    const status = campaignStatus[item.campaign_status];

    if (!status) return null;

    const days = parseInt(item.days_left, 10);
    let note = '';

    if (item.campaign_status === 'EXPIRING') {
      note = days === 0 ? ' · วันสุดท้าย' : ` · เหลือ ${days} วัน`;
    } else if (item.campaign_status === 'EXPIRED') {
      note = ` · เลยมา ${Math.abs(days)} วัน`;
    } else if (item.campaign_status === 'SCHEDULED') {
      note = ` · อีก ${item.days_to_start} วัน`;
    }

    return (
      <Chip size='small' color={status.color} label={`${status.label}${note}`} sx={{ mt: 0.5 }} />
    );
  };

  const renderList = () => {
    return (
      <MDBox mb={7}>
        <Navbar route={[t(`menu.product`), t(`menu.campaign`)]} />
        <Grid container spacing={2}>
          <Grid item xs={12} sm={9} md={10} lg={11}>
            {renderSearch()}
          </Grid>
          <Grid item xs={12} sm={3} md={2} lg={1}>
            <MDButton
              variant='contained'
              color='dark'
              size='large'
              fullWidth
              sx={{ pt: 1.6, pb: 1.6 }}
              onClick={() => {
                setAttr(initAttr);
                setConfirm(false);
                setModalAdd(true);
              }}
            >
              <Icon>post_add</Icon>
            </MDButton>
          </Grid>
          <Grid item xs={12}>
            <TableContainer component={Paper} sx={{ minHeight: 400 }}>
              <Table aria-label='datatable table'>
                <TableHeader
                  order={order}
                  orderBy={orderBy}
                  onRequestSort={handleSort}
                  data={initHeader}
                />
                <TableBody>
                  {record.map((row) => (
                    <TableRow key={row.id} hover>
                      <TableCell align='center'>{Func.imageDisplay(row)}</TableCell>
                      <TableCell align='left'>
                        <MDBox>{btnOpen(row)}</MDBox>
                        <MDBox className='nowrap'>{row.name}</MDBox>
                      </TableCell>
                      <TableCell align='left' className='nowrap'>
                        {promotionDisplay(row.promotion_type)}
                      </TableCell>
                      <TableCell align='center' className='nowrap'>
                        <MDBox>{dateStartStop(row)}</MDBox>
                        <MDBox>{statusChip(row)}</MDBox>
                      </TableCell>
                      <TableCell align='center'>
                        <CampaignBranchUse parent={row} reload={reloadList} type='list' />
                      </TableCell>
                      <TableCell align='right' className='color-info'>
                        {row.promotion_type === 'B' ? '' : Func.numberDisplay(row.quantity)}
                      </TableCell>
                      <TableCell align='right'>
                        {row.promotion_type === 'C' ? null : (
                          <CampaignBranch parent={row} reload={reloadList} type='list' />
                        )}
                      </TableCell>
                      <TableCell align='center'>{enableDisplay(row.enable)}</TableCell>
                      <TableCell align='center'>{btnMove(row)}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          <Grid item xs={12}>
            <Card sx={{ p: 2 }}>
              <MDBox display='flex' justifyContent='space-between' alignItems='flex-start'>
                <MDButton variant={show ? 'contained' : 'outlined'} color='dark' onClick={openShow}>
                  {t(`element.show_record`, { num: find.perPage })}&nbsp;
                  <Icon>keyboard_arrow_down</Icon>
                </MDButton>
                {renderShow}
                <Pagination
                  count={pageTotal}
                  variant='outlined'
                  color='secondary'
                  showFirstButton
                  showLastButton
                  page={pageNo}
                  onChange={(e, p) => view({ ...find, page: p })}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const renderInfoPromotionA = () => {
    return (
      <MDBox className='card' p={2}>
        <MDTypography variant='h6' mb={3}>
          ราคาขาย
        </MDTypography>
        <Grid container spacing={2}>
          <Grid item xs={12} md={12} lg={12}>
            <MDInput
              label='ปริมาณการซื้อ'
              onChange={(e) => setAttr({ ...attr, quantity: e.target.value })}
              value={attr.quantity}
              variant='standard'
              fullWidth
              inputProps={{
                autoComplete: 'off',
              }}
            />
          </Grid>
          <Grid item xs={12} md={12} lg={12}>
            <MDInput
              label='ราคาขาย'
              onChange={(e) => setAttr({ ...attr, price: e.target.value })}
              value={attr.price}
              variant='standard'
              fullWidth
              InputProps={{
                maxLength: 50,
                autoFocus: true,
                endAdornment: (
                  <InputAdornment position='end'>
                    <CampaignBranch parent={attr} reload={reload} type='data' />
                  </InputAdornment>
                ),
                inputProps: {
                  autoComplete: 'off',
                },
              }}
            />
          </Grid>
          <Grid item xs={12} md={12} lg={12} display='flex' justifyContent='flex-end'>
            <MDButton variant='outlined' color='success' onClick={editPromotionA}>
              <Icon>save</Icon>&nbsp;{t(`element.save`)}
            </MDButton>
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const renderInfoPromotionB = () => {
    return (
      <MDBox className='card' p={2}>
        <MDTypography variant='h6' mb={3}>
          มูลค่าซื้อครบ
        </MDTypography>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <MDInput
              label='ราคา'
              onChange={(e) => setAttr({ ...attr, price: e.target.value })}
              value={attr.price}
              variant='standard'
              fullWidth
              InputProps={{
                maxLength: 50,
                autoFocus: true,
                endAdornment: (
                  <InputAdornment position='end'>
                    <CampaignBranch parent={attr} reload={reload} type='data' />
                  </InputAdornment>
                ),
                inputProps: {
                  autoComplete: 'off',
                },
              }}
            />
          </Grid>
          <Grid item xs={12} md={12} lg={12} display='flex' justifyContent='flex-end'>
            <MDButton variant='outlined' color='success' onClick={editPromotionB}>
              <Icon>save</Icon>&nbsp;{t(`element.save`)}
            </MDButton>
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const renderInfoPromotionC = () => {
    return (
      <MDBox className='card' p={2}>
        <MDTypography variant='h6' mb={3}>
          มูลค่าซื้อครบ
        </MDTypography>
        <Grid container spacing={2}>
          <Grid item xs={12} md={12} lg={12}>
            <MDInput
              label='ปริมาณการซื้อ'
              onChange={(e) => setAttr({ ...attr, quantity: e.target.value })}
              value={attr.quantity}
              variant='standard'
              fullWidth
              inputProps={{
                autoComplete: 'off',
              }}
            />
          </Grid>
          <Grid item xs={12} md={12} lg={12}>
            <MDInput
              label='จำนวนของแถม'
              onChange={(e) => setAttr({ ...attr, amount: e.target.value })}
              value={attr.amount}
              variant='standard'
              fullWidth
              inputProps={{
                autoComplete: 'off',
              }}
            />
          </Grid>
          <Grid item xs={12} md={12} lg={12} display='flex' justifyContent='flex-end'>
            <MDButton variant='outlined' color='success' onClick={editPromotionC}>
              <Icon>save</Icon>&nbsp;{t(`element.save`)}
            </MDButton>
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const renderInfoPromotionE = () => {
    return (
      <MDBox className='card' p={2}>
        <MDTypography variant='h6' mb={3}>
          ราคาขาย
        </MDTypography>
        <Grid container spacing={2}>
          <Grid item xs={12} md={12} lg={12}>
            <MDInput
              label='มูลค่าการซื้อ'
              onChange={(e) => setAttr({ ...attr, quantity: e.target.value })}
              value={attr.quantity}
              variant='standard'
              fullWidth
              inputProps={{
                autoComplete: 'off',
              }}
            />
          </Grid>
          <Grid item xs={12} md={12} lg={12}>
            <MDInput
              label='ส่วนลด'
              onChange={(e) => setAttr({ ...attr, price: e.target.value })}
              value={attr.price}
              variant='standard'
              fullWidth
              InputProps={{
                maxLength: 50,
                autoFocus: true,
                endAdornment: (
                  <InputAdornment position='end'>
                    <CampaignBranch parent={attr} reload={reload} type='data' />
                  </InputAdornment>
                ),
                inputProps: {
                  autoComplete: 'off',
                },
              }}
            />
          </Grid>
          <Grid item xs={12} md={12} lg={12} display='flex' justifyContent='flex-end'>
            <MDButton variant='outlined' color='success' onClick={editPromotionE}>
              <Icon>save</Icon>&nbsp;{t(`element.save`)}
            </MDButton>
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const renderInfo = () => {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12} md={6} xl={3}>
          <MDBox className='card' p={2}>
            <MDTypography variant='h6' mb={3}>
              แคมเปญ
            </MDTypography>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                {attr.image === '' ? null : (
                  <MDBox
                    component='img'
                    src={attr.image}
                    alt={attr.name}
                    width='100%'
                    height='100%'
                  />
                )}
              </Grid>
              {/* <Grid item xs={12}>
                <MDInput
                  label="รหัสแคมเปญ"
                  onChange={(e) => setAttr({ ...attr, code: e.target.value })}
                  value={attr.code}
                  variant="standard"
                  fullWidth
                  inputProps={{
                    autoComplete: "off",
                  }}
                />
              </Grid> */}
            </Grid>
          </MDBox>
        </Grid>
        <Grid item xs={12} md={6} xl={3}>
          <MDBox className='card' p={2}>
            <MDTypography variant='h6' mb={3}>
              ข้อมูลแคมเปญ (ภาษาไทย)
            </MDTypography>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <MDInput
                  label='ชื่อแคมเปญ'
                  onChange={(e) => setAttr({ ...attr, name: e.target.value })}
                  value={attr.name}
                  variant='standard'
                  fullWidth
                  multiline
                  inputProps={{
                    autoComplete: 'off',
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <MDInput
                  label='ชื่อโปรโมชั่น'
                  onChange={(e) => setAttr({ ...attr, promotion_name: e.target.value })}
                  value={attr.promotion_name}
                  variant='standard'
                  fullWidth
                  multiline
                  inputProps={{
                    autoComplete: 'off',
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <MDInput
                  label='รายละเอียด ย่อ'
                  onChange={(e) => setAttr({ ...attr, detail: e.target.value })}
                  value={attr.detail}
                  variant='standard'
                  fullWidth
                  multiline
                  rows={5}
                  inputProps={{
                    autoComplete: 'off',
                  }}
                />
              </Grid>
            </Grid>
          </MDBox>
          <MDBox className='card' p={2} mt={2}>
            <MDTypography variant='h6' mb={3}>
              ข้อมูลแคมเปญ (ภาษาอังกฤษ)
            </MDTypography>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <MDInput
                  label='ชื่อแคมเปญ'
                  onChange={(e) => setAttr({ ...attr, name_en: e.target.value })}
                  value={attr.name_en}
                  variant='standard'
                  fullWidth
                  inputProps={{
                    autoComplete: 'off',
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <MDInput
                  label='ชื่อโปรโมชั่น'
                  onChange={(e) => setAttr({ ...attr, promotion_name_en: e.target.value })}
                  value={attr.promotion_name_en}
                  variant='standard'
                  fullWidth
                  inputProps={{
                    autoComplete: 'off',
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <MDInput
                  label='รายละเอียด ย่อ'
                  onChange={(e) => setAttr({ ...attr, detail_en: e.target.value })}
                  value={attr.detail_en}
                  variant='standard'
                  fullWidth
                  multiline
                  rows={5}
                  inputProps={{
                    autoComplete: 'off',
                  }}
                />
              </Grid>
            </Grid>
          </MDBox>
        </Grid>
        <Grid item xs={12} md={6} xl={3}>
          <MDBox className='card' p={2}>
            <MDTypography variant='h6' mb={3}>
              ประเภท
            </MDTypography>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <MDSelect
                  label='ประเภทโปรโมชั่น'
                  labelDefault={t(`element.please_select`)}
                  data={cboType}
                  value={attr.promotion_type}
                  onChange={(e) => setAttr({ ...attr, promotion_type: e.target.value })}
                  inputProps={{
                    autoComplete: 'off',
                  }}
                />
              </Grid>
              {/* <Grid item xs={12}>
                <MDSelect
                  label="ประเภท สินค้า"
                  labelDefault={t(`element.please_select`)}
                  data={cboCat}
                  value={attr.cat_id}
                  onChange={(e) => setAttr({ ...attr, cat_id: e.target.value })}
                  inputProps={{
                    autoComplete: "off",
                  }}
                />
              </Grid> */}
              {/* <Grid item xs={12}>
                <MDSelect
                  label="หมวดหมู่"
                  labelDefault={t(`element.please_select`)}
                  data={cboSubCat}
                  value={attr.subcat_id}
                  onChange={(e) => setAttr({ ...attr, subcat_id: e.target.value })}
                  inputProps={{
                    autoComplete: "off",
                  }}
                />
              </Grid> */}
              <Grid item xs={12}>
                <MDSelect
                  label='ภาษีมูลค่าเพิ่ม'
                  labelDefault={t(`element.please_select`)}
                  data={cboVatType}
                  value={attr.vat_id}
                  onChange={(e) => setAttr({ ...attr, vat_id: e.target.value })}
                  inputProps={{
                    autoComplete: 'off',
                  }}
                />
              </Grid>
            </Grid>
          </MDBox>
          <MDBox className='card' p={2} mt={2}>
            <MDTypography variant='h6' mb={3}>
              ช่วงเวลา
            </MDTypography>
            <Grid container spacing={2}>
              <Grid item xs={7}>
                <MDDatePicker
                  onChange={([date]) => {
                    setAttr({ ...attr, date_start: Func.dateFormat(date) });
                  }}
                  value={new Date(attr.date_start)}
                  input={{
                    label: 'เริ่มต้น',
                    variant: 'standard',
                    fullWidth: true,
                  }}
                />
              </Grid>
              <Grid item xs={5}>
                <MDInput
                  label='เวลา'
                  onChange={(e) => setAttr({ ...attr, time_start: e.target.value })}
                  value={attr.time_start}
                  variant='standard'
                  fullWidth
                  type='time'
                  inputProps={{
                    autoComplete: 'off',
                  }}
                />
              </Grid>
              <Grid item xs={7}>
                <MDDatePicker
                  onChange={([date]) => {
                    setAttr({ ...attr, date_stop: Func.dateFormat(date) });
                  }}
                  value={new Date(attr.date_stop)}
                  input={{
                    label: 'สิ้นสุด',
                    variant: 'standard',
                    fullWidth: true,
                  }}
                />
              </Grid>
              <Grid item xs={5}>
                <MDInput
                  label='เวลา'
                  onChange={(e) => setAttr({ ...attr, time_stop: e.target.value })}
                  value={attr.time_stop}
                  variant='standard'
                  fullWidth
                  type='time'
                  inputProps={{
                    autoComplete: 'off',
                  }}
                />
              </Grid>
            </Grid>
          </MDBox>
        </Grid>
        <Grid item xs={12} md={6} xl={3}>
          <MDBox className='card' p={2}>
            <MDTypography variant='h6' mb={3}>
              อื่น ๆ
            </MDTypography>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <MDCheckbox
                  label='สามารถขายได้'
                  checked={attr.enable === 'Y'}
                  onChange={(e) => setAttr({ ...attr, enable: e.target.checked ? 'Y' : 'N' })}
                />
              </Grid>
            </Grid>
          </MDBox>
        </Grid>
      </Grid>
    );
  };

  const renderAdd = () => {
    return (
      <Dialog open={modalAdd} maxWidth='xs' keepMounted aria-describedby='dialog-add' fullWidth>
        <DialogTitle>
          {t(`element.add`)}
          <IconButton
            aria-label='close'
            onClick={() => setModalAdd(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <MDBox p={3}>
            <Grid container spacing={2}>
              {/* <Grid item xs={12}>
                <MDInput
                  label="รหัสแคมเปญ"
                  onChange={(e) => setAttr({ ...attr, code: e.target.value })}
                  value={attr.code}
                  variant="standard"
                  fullWidth
                  inputProps={{
                    autoComplete: "off",
                  }}
                />
              </Grid> */}
              <Grid item xs={12}>
                <MDInput
                  label='ชื่อแคมเปญ'
                  onChange={(e) => setAttr({ ...attr, name: e.target.value })}
                  value={attr.name}
                  variant='standard'
                  fullWidth
                  multiline
                  inputProps={{
                    autoComplete: 'off',
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <MDInput
                  label='ชื่อโปรโมชั่น'
                  onChange={(e) => setAttr({ ...attr, promotion_name: e.target.value })}
                  value={attr.promotion_name}
                  variant='standard'
                  fullWidth
                  multiline
                  inputProps={{
                    autoComplete: 'off',
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <MDSelect
                  label='ประเภทโปรโมชั่น'
                  labelDefault={t(`element.please_select`)}
                  data={cboType}
                  value={attr.promotion_type}
                  onChange={(e) => setAttr({ ...attr, promotion_type: e.target.value })}
                  inputProps={{
                    autoComplete: 'off',
                  }}
                />
              </Grid>
              <Grid item xs={7}>
                <MDDatePicker
                  onChange={([date]) => {
                    setAttr({ ...attr, date_start: Func.dateFormat(date) });
                  }}
                  value={new Date(attr.date_start)}
                  input={{
                    label: 'เริ่มต้น',
                    variant: 'standard',
                    fullWidth: true,
                  }}
                />
              </Grid>
              <Grid item xs={5}>
                <MDInput
                  label='เวลา'
                  onChange={(e) => setAttr({ ...attr, time_start: e.target.value })}
                  value={attr.time_start}
                  variant='standard'
                  fullWidth
                  type='time'
                  inputProps={{
                    autoComplete: 'off',
                  }}
                />
              </Grid>
              <Grid item xs={7}>
                <MDDatePicker
                  onChange={([date]) => {
                    setAttr({ ...attr, date_stop: Func.dateFormat(date) });
                  }}
                  value={new Date(attr.date_stop)}
                  input={{
                    label: 'สิ้นสุด',
                    variant: 'standard',
                    fullWidth: true,
                  }}
                />
              </Grid>
              <Grid item xs={5}>
                <MDInput
                  label='เวลา'
                  onChange={(e) => setAttr({ ...attr, time_stop: e.target.value })}
                  value={attr.time_stop}
                  variant='standard'
                  fullWidth
                  type='time'
                  inputProps={{
                    autoComplete: 'off',
                  }}
                />
              </Grid>
            </Grid>
          </MDBox>
        </DialogContent>
        <DialogActions>
          {confirm ? (
            <Grid container>
              <Grid item xs={6}>
                <MDButton variant='text' color='error' onClick={() => setConfirm(false)}>
                  <Icon>cancel</Icon>&nbsp;{t(`element.cancel`)}
                </MDButton>
              </Grid>
              <Grid item xs={6} display='flex' justifyContent='flex-end'>
                <MDButton variant='outlined' color='success' onClick={add}>
                  <Icon>save</Icon>&nbsp;{t(`element.saveconfirm`)}
                </MDButton>
              </Grid>
            </Grid>
          ) : (
            <MDButton variant='text' color='info' onClick={addConfirm}>
              <Icon>save</Icon>&nbsp;{t(`element.save`)}
            </MDButton>
          )}
        </DialogActions>
      </Dialog>
    );
  };

  const renderImage = () => {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12} lg={3}>
          <MDBox>
            <Paper sx={{ p: 2 }} variant='outlined'>
              {attr.image === '' ? null : (
                <MDBox
                  component='img'
                  src={attr.image}
                  alt={attr.name}
                  borderRadius='lg'
                  shadow='sm'
                  width='100%'
                  height='100%'
                  position='relative'
                  zIndex={10}
                />
              )}
              <MDBox mt={2} display='flex' justifyContent='center'>
                <CampaignUpload uploadData={upload} />
              </MDBox>
              <MDBox mt={1} display='flex' justifyContent='center'>
                <MDButton
                  variant='outlined'
                  color='info'
                  size='small'
                  onClick={() => setPickGraphic(true)}
                >
                  <Icon>auto_awesome</Icon>&nbsp;เลือกจากกราฟิก AI
                </MDButton>
              </MDBox>
              <CampaignGraphicPicker
                open={pickGraphic}
                token={app.token}
                campaignId={id}
                mainImageId={Number(attr.image_id) || 0}
                onClose={() => setPickGraphic(false)}
                onDone={() => {
                  setPickGraphic(false);
                  reloadImages().then(() => showNotify('ตั้งเป็นภาพหลักแล้ว', 'success'));
                }}
                onCreate={() => {
                  setPickGraphic(false);
                  setTab(5);
                }}
              />
            </Paper>
          </MDBox>
        </Grid>
        <Grid item xs={12} xl={9}>
          <MDBox>
            <Grid container spacing={2}>
              {image.map((item) => (
                <Grid key={item.id} item xs={12} xl={4}>
                  <Paper sx={{ p: 2 }} variant='outlined'>
                    <MDBox
                      component='img'
                      src={item.image}
                      alt={attr.name}
                      borderRadius='lg'
                      shadow='sm'
                      width='100%'
                      height='100%'
                      position='relative'
                      zIndex={10}
                    />
                    <MDBox mt={2} display='flex' justifyContent='center'>
                      <MDButton
                        variant='gradient'
                        color='light'
                        size='small'
                        component='span'
                        onClick={() => pin(item.id)}
                      >
                        <Icon>push_pin</Icon>&nbsp;ตั้งเป็นภาพหลัก
                      </MDButton>
                    </MDBox>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </MDBox>
        </Grid>
      </Grid>
    );
  };

  const renderNavigate = () => {
    return (
      <Card sx={{ p: 2 }}>
        <Grid container>
          <Grid item xs={6}>
            <NavLink to={`/${mod}`}>
              <MDButton variant='contained' color='dark'>
                <Icon>arrow_back</Icon>&nbsp;{t(`element.back`)}
              </MDButton>
            </NavLink>
          </Grid>
          {navigate.first === '' ? null : (
            <Grid item xs={6}>
              <MDBox display='flex' justifyContent='flex-end' gap={1}>
                <NavLink to={`/${mod}/${navigate.first}`}>
                  <MDButton
                    variant='contained'
                    color='dark'
                    iconOnly
                    disabled={navigate.first === id}
                  >
                    <Icon>first_page</Icon>
                  </MDButton>
                </NavLink>
                <NavLink to={`/${mod}/${navigate.prev}`}>
                  <MDButton
                    variant='contained'
                    color='dark'
                    iconOnly
                    disabled={navigate.prev === id}
                  >
                    <Icon>navigate_before</Icon>
                  </MDButton>
                </NavLink>
                <NavLink to={`/${mod}/${navigate.next}`}>
                  <MDButton
                    variant='contained'
                    color='dark'
                    iconOnly
                    disabled={navigate.next === id}
                  >
                    <Icon>navigate_next</Icon>
                  </MDButton>
                </NavLink>
                <NavLink to={`/${mod}/${navigate.last}`}>
                  <MDButton
                    variant='contained'
                    color='dark'
                    iconOnly
                    disabled={navigate.last === id}
                  >
                    <Icon>last_page</Icon>
                  </MDButton>
                </NavLink>
              </MDBox>
            </Grid>
          )}
        </Grid>
      </Card>
    );
  };

  const renderYoutube = () => {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12} md={12} lg={12} xl={6}>
          <MDBox className='card' p={2}>
            <Grid container spacing={2}>
              <Grid item xs={10}>
                <MDInput
                  label='Youtube ID'
                  onChange={(e) => setAttr({ ...attr, youtube: e.target.value })}
                  value={attr.youtube}
                  variant='standard'
                  fullWidth
                  inputProps={{
                    autoComplete: 'off',
                  }}
                />
              </Grid>
              <Grid item xs={2}>
                <MDButton variant='outlined' color='success' onClick={editYoutube}>
                  <Icon>save</Icon>&nbsp;{t(`element.save`)}
                </MDButton>
              </Grid>
              <Grid item xs={12}>
                {attr.youtube === '' ? null : (
                  <YouTube
                    videoId={attr.youtube}
                    opts={{
                      height: '360',
                      width: '640',
                      playerVars: {
                        autoplay: 0,
                      },
                    }}
                    onReady={(e) => {
                      e.target.pauseVideo();
                    }}
                  />
                )}
              </Grid>
            </Grid>
          </MDBox>
        </Grid>
      </Grid>
    );
  };

  const renderDetail = () => {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12} xl={6}>
          <MDBox className='card' p={2}>
            <MDTypography variant='h6' mb={3}>
              รายละเอียด ภาษาไทย
            </MDTypography>
            <MDEditor value={content} onChange={setContent} />
          </MDBox>
        </Grid>
        <Grid item xs={12} xl={6}>
          <MDBox className='card' p={2}>
            <MDTypography variant='h6' mb={3}>
              รายละเอียด ภาษาอังกฤษ
            </MDTypography>
            <MDEditor value={contentEN} onChange={setContentEN} />
          </MDBox>
        </Grid>
        <Grid item xs={12} display='flex' justifyContent='flex-end' gap={1}>
          <MDButton variant='outlined' color='success' onClick={editContent}>
            <Icon>save</Icon>&nbsp;{t(`element.save`)}
          </MDButton>
        </Grid>
      </Grid>
    );
  };

  const branchUse = () => {
    return (
      <MDBox className='card' p={2} mt={2}>
        <MDTypography variant='h6' mb={3}>
          สาขาที่ใช้งาน
        </MDTypography>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <CampaignBranchUse parent={attr} reload={reloadInfo} type='list' />
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const toggleIsAllProducts = (checked) => {
    const value = checked ? 'Y' : 'N';
    setAttr({ ...attr, is_all_products: value });
    FetchData('PATCH', `/${mod}/${attr.id}`, app.token, {
      is_all_products: value,
    }).then((result) => {
      if (result.status === 'ok') {
        showNotify(t(`alert.editcomplete`), 'success');
      } else {
        setAttr({ ...attr, is_all_products: checked ? 'N' : 'Y' });
        showNotify(t(`alert.${result.msg}`), 'error');
      }
    });
  };

  const renderProductList = () => {
    return (
      <MDBox className='card' p={2} mb={['B', 'C'].includes(promotion) ? 2 : 0}>
        <MDBox display='flex' justifyContent='space-between' alignItems='center' mb={3}>
          <MDTypography variant='h6'>รายการสินค้า</MDTypography>
          <MDCheckbox
            label='สินค้าทุกตัวเข้าร่วม'
            checked={attr.is_all_products === 'Y'}
            onChange={(e) => toggleIsAllProducts(e.target.checked)}
          />
        </MDBox>
        {attr.is_all_products !== 'Y' && <CampaignList promotion={promotion} />}
      </MDBox>
    );
  };

  const renderPromotion = () => {
    return promotion === 'A' ? (
      <Grid container mb={3} spacing={2}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={3}>
          {renderInfoPromotionA()}
          {branchUse()}
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={9}>
          {renderProductList()}
        </Grid>
      </Grid>
    ) : promotion === 'B' ? (
      <Grid container mb={3} spacing={2}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={3}>
          {renderInfoPromotionB()}
          {branchUse()}
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={9}>
          {renderProductList()}
          <MDBox className='card' p={2}>
            <MDTypography variant='h6' mb={3}>
              รายการของแถม
            </MDTypography>
            <CampaignFree />
          </MDBox>
        </Grid>
      </Grid>
    ) : promotion === 'C' ? (
      <Grid container mb={3} spacing={2}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={3}>
          {renderInfoPromotionC()}
          {branchUse()}
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={9}>
          {renderProductList()}
          <MDBox className='card' p={2}>
            <MDTypography variant='h6' mb={3}>
              รายการของแถม
            </MDTypography>
            <CampaignFree />
          </MDBox>
        </Grid>
      </Grid>
    ) : promotion === 'D' ? (
      <Grid container mb={3} spacing={2}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={3}>
          {renderInfoPromotionA()}
          {branchUse()}
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={9}>
          {renderProductList()}
        </Grid>
      </Grid>
    ) : promotion === 'E' ? (
      <Grid container mb={3} spacing={2}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={3}>
          {renderInfoPromotionE()}
          {branchUse()}
        </Grid>
      </Grid>
    ) : null;
  };

  const renderOpen = () => {
    return (
      <MDBox mb={7}>
        <Navbar route={[t(`menu.product`), `${attr.code} : ${attr.name}`]} />
        <Grid container spacing={2}>
          <Grid item xs={12}>
            {renderNavigate()}
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <Card sx={{ p: 2 }}>
              <MDBox sx={{ width: '100%' }}>
                <MDBox>
                  <Tabs value={tab} onChange={(e, v) => setTab(v)} aria-label='tabs-addedit'>
                    <Tab label={t(`element.info`)} />
                    <Tab label={promotionDisplay(promotion)} />
                    <Tab label='รายละเอียด' />
                    <Tab label='วีดีโอ' />
                    <Tab label='รูปภาพ' />
                    <Tab label='กราฟิก AI' />
                    <Grid item xs={12} display='flex' justifyContent='flex-end' gap={1} m={1}>
                      <MDButton variant='outlined' color='info' onClick={copy}>
                        <Icon>content_copy_two_tone</Icon>&nbsp; Copy เป็นแคมเปญใหม่
                      </MDButton>
                    </Grid>
                  </Tabs>
                </MDBox>
                <TabPanel value={tab} index={0}>
                  <Grid container>
                    <Grid item xs={12}>
                      {renderInfo()}
                      <Grid container mt={3}>
                        <Grid item xs={12} display='flex' justifyContent='flex-end' gap={1}>
                          <MDButton variant='outlined' color='success' onClick={edit}>
                            <Icon>save</Icon>&nbsp;{t(`element.save`)}
                          </MDButton>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </TabPanel>
                <TabPanel value={tab} index={1}>
                  {renderPromotion()}
                </TabPanel>
                <TabPanel value={tab} index={2}>
                  {renderDetail()}
                </TabPanel>
                <TabPanel value={tab} index={3}>
                  {renderYoutube()}
                </TabPanel>
                <TabPanel value={tab} index={4}>
                  {renderImage()}
                </TabPanel>
                <TabPanel value={tab} index={5}>
                  <CampaignGraphic onSaved={reloadImages} onOpenImages={() => setTab(4)} />
                </TabPanel>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const renderPage = () => {
    if (id === undefined) return renderList();
    return renderOpen();
  };

  useEffect(() => {
    i18n.changeLanguage(app.lang);

    init();
  }, [id]);

  return (
    <DashboardLayout>
      {renderPage()}
      {renderAdd()}
      <Footer />
      {renderLoading()}
      {notify}
    </DashboardLayout>
  );
}

export default Campaign;
